import { useMemo } from 'react'
import StarterKit from '@tiptap/starter-kit'
import { RichTextReadOnly } from 'mui-tiptap'

const RTEView = ({ content, mb, fontWeight, fontSize, cut = false }) => {
  const extensions = useMemo(() => [StarterKit], [])

  return (
    <RichTextReadOnly
      key={content}
      sx={{
        marginBottom: mb || 0,
        '& .ProseMirror': {
          ...(fontWeight && { fontWeight: fontWeight }),
          ...(fontSize && { fontSize: fontSize }),
          ...(cut && {
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          })
        }
      }}
      content={content}
      extensions={extensions}
    />
  )
}

export default RTEView
